import React from 'react';
import Link from 'components/Link';

const PageLinks = () => (
  <div style={{ opacity: 0, position: 'absolute' }}>
    <Link to="/orderskyminer" />
    <Link to="/gallery" />
    <Link to="/thankyou" />
    <Link to="/terms" />
    <Link to="/cookies" />
    <Link to="/whitepapers" />
    <Link to="/infographics" />
    <Link to="/architecture-overview" />
    <Link to="/mailing-list" />
    <Link to="/ecosystem" />
    <Link to="/skyminer" />
    <Link to="/skywire" />
    <Link to="/skywallet" />
    <Link to="/cxo" />
    <Link to="/cx" />
    <Link to="/cx/home" />
    <Link to="/cx/docs" />
    <Link to="/cx/example" />
    <Link to="/cx/about" />
    <Link to="/cx/chains" />
    <Link to="/cx/installation" />
    <Link to="/fiber" />
    <Link to="/jobs" />
    <Link to="/whiteListForm" />
    <Link to="/whiteList" />
    <Link to="/obelisk" />
    <Link to="/landing/skywire" />
    <Link to="/landing/skywallet" />
    <Link to="/landing/skyminer" />
    <Link to="/landing/cx" />
    <Link to="/landing/skycoin" />
    <Link to="/landing/nyc-meetup" />
    <Link to="/landing/mobile-wallets" />
    <Link to="/qrcode" />
    <Link to="/pressreleases" />
    <Link to="/pressreleases/release-2019-03-20" />
    <Link to="/pressreleases/release-2019-08-23" />
    <Link to="/pressreleases/release-2019-10-14" />
    <Link to="/pressreleases/release-2019-10-18" />
    <Link to="/pressreleases/release-2019-11-26" />
  </div>
);

export default PageLinks;



// WEBPACK FOOTER //
// ./src/components/Footer/components/PageLinks/PageLinks.js